import React, { useState, useEffect, useRef } from 'react';
import { useStateValue } from './AppContext.jsx';
import Animal from './Animal.jsx';
import {getAnimals} from './AnimalFunctions.jsx';
import 'whatwg-fetch';

function makeContent(res) {
  if (res === false) {
    return showLoading();
  }
  else if (res.status === "error") {
    return showError(res.message);
  }
  else if (res.animals && res.animals.length === 0) {
    return showEmpty();
  }
  else {
    return showAnimals(res.animals);
  }
}

function showLoading(){
  return [<p key="loading">Loading</p>];
}


function showError(message){
  return [<p key="error">Error: {message}</p>];
}

function showEmpty(){
  return [<p ><span class="stray-no-found">No strays in our care at this time.</span><span class="adopt-no-found">No animals for adoption at this time.</span></p>];
}

function showAnimals(animals){
  return animals.map(animal => 
    <Animal key={animal.animal_id} {...animal} />
  );
}



function AnimalList() {
  const [ {siteBase, filters} ] = useStateValue();
  const [content, setContent] = useState([]);
  const [listState, setListState] = useState({page: 0, loadMore: false, fetching: false});
  const [hasMore, setHasMore] = useState(true);
  const signature = JSON.stringify(filters.map(filter => filter.value));
  const listRef = useRef();

  async function fetchData(pageNum) {
    let activeFilters = {};
    for (let i = 0; i < filters.length; i++) {
      activeFilters[filters[i].query] = filters[i].value;
    }
    pageNum = typeof pageNum === "undefined" ? listState.page : pageNum;
    let fetch = getAnimals(siteBase, activeFilters, pageNum);
    fetch
      .then(results => {
        // Check if there are animals
        if (results.animals && results.animals.length === 0) {
          // If we're on the first page, show "No results"
          if (pageNum === 0) {
            setContent(showEmpty());
          }
          // Otherwise, just stop trying to load more
          setHasMore(false);
          setListState(current => ({...current, loadMore: false, fetching: false}));
          return;
        }

        // There are animals, so append them
        const newContent = showAnimals(results.animals);
        // For first page, simply set; for paginated loads, append.
        if (pageNum === 0) {
          setContent(newContent);
        } else {
          setContent(current => [...current, ...newContent]);
        }
        setListState(current => ({...current, loadMore: false, fetching: false}));
      })
      .catch(() => {
        setContent([]);
      });
  }

  // When filters change, reset the list and hasMore flag.
  useEffect(() => {
    setContent([]);
    setListState(current => ({...current, page: 0}));
    setHasMore(true);
    fetchData(0);
  }, [signature]);

  // Load additional pages on scroll
  useEffect(() => {
    if (listState.loadMore === true && listState.fetching === false && hasMore) {
      let nextPage = listState.page + 1;
      setListState({page: nextPage, loadMore: false, fetching: true});
    }
  }, [listState.loadMore, hasMore]);

  useEffect(() => {
    if (listState.page > 0) {
      fetchData();
    }
  }, [listState.page]);

  // Watch the scroll only if there are more items to load
  useEffect(() => {
    const scrollWatcher = () => {
      let list = listRef.current;
      if (
        list &&
        window.scrollY + window.innerHeight >= list.clientHeight + list.offsetTop &&
        listState.loadMore === false &&
        hasMore
      ) {
        setListState(state => ({...state, loadMore: true}));
      }
    };

    window.addEventListener('scroll', scrollWatcher);
    return () => window.removeEventListener('scroll', scrollWatcher);
  }, [listState.loadMore, hasMore]);

  // Render logic: On initial load, if no content, show "Loading"
  if (!content.length && listState.page === 0) {
    return (
      <div className="animalList">
        {showLoading()}
      </div>
    );
  } else {
    return (
      <div className="animalList" ref={listRef}>
        {content}
      </div>
    );
  }
}

export default AnimalList;